import { UserX } from "lucide-react";
import { relTime } from "@/lib/format";

export function RecipientWarnings({ recipients }) {
  if (!recipients?.length) return null;
  return (
    <div data-testid="delivery-recipient-warnings">
      <div className="eyebrow mb-1.5 text-amber-300 flex items-center gap-1.5"><UserX className="h-3 w-3" /> Recipients with delivery problems · last 30 days</div>
      <ul className="divide-y divide-[#1f293d]">
        {recipients.map((r) => (
          <li key={r.email} className="py-1.5 px-1 text-xs flex flex-wrap items-center gap-x-3 gap-y-0.5" data-testid={`delivery-recipient-${r.email}`}>
            <span className="text-slate-200 font-semibold">{r.name || "Unknown"}</span>
            <span className="font-mono text-slate-400">{r.email}</span>
            <span className="font-mono text-slate-500 ml-auto whitespace-nowrap">
              {r.bounced ? <span className="text-red-300">{r.bounced} bounced</span> : null}
              {r.complained ? <span className="text-red-300 ml-2">{r.complained} spam</span> : null}
              {r.failed ? <span className="text-amber-300 ml-2">{r.failed} failed</span> : null}
              <span className="ml-2">· {relTime(r.last_at)}</span>
            </span>
            {r.last_error && <div className="w-full text-[11px] text-slate-500 truncate">{r.last_error}</div>}
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-slate-500 mt-1.5">Bounced addresses are usually typos or departed employees — fix the email on the OpenPhone user (Settings → Monitored users) or the Users page, then use “Resend to…”.</p>
    </div>
  );
}
